/*
 *
 * LeadsPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { mapIsEmpty } from 'utils/helpers';
import { RouteSubRoutes } from 'routes';
import { createStructuredSelector } from 'reselect';
import { selectAllLeads } from './selectors';
import { Wrapper } from './styledComponents';
import { fetchLeadsRequest } from './actions';

class LeadsPage extends React.PureComponent {
  render() {
    const { routes } = this.props;
    return (
      <Wrapper>
        <Helmet title='Movebooth | Leads' />
        <div className='leads-page__content'>
          {routes.map((r, i) =>
            <RouteSubRoutes key={i} {...r} />
          )}
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  leads: selectAllLeads(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchLeads: () => dispatch(fetchLeadsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadsPage);



// WEBPACK FOOTER //
// ./src/containers/LeadsPage/index.js